
import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import {ZIDXMultiPanelSlider, ZIDXMultiPanelSliderOptions} from "../MultiPanelSlider.js";
import {SavedListingRepository} from "../saved-listings/SavedListingRepository.js";
import {ContactSaveListing, ContactListingAction} from "./ContactSaveListing.js";
import {ListingViewGate} from "./ListingViewGate.js";

let $=jQuery.noConflict();

export class ZIDXListingDetail implements ZIDXPage{
    slideData:string="";
    slider:ZIDXMultiPanelSlider|null=null;
    zidx:ZIDX;
    mapAccordionItem:HTMLDivElement|null=null;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxListingDetailContainer";
    }
    render(){
        // console.log("listing detail");
        // let j=new JetendoJSS();
        // j.generate();
        let self=this;
        $(".zidxListingInquireButton", this.zidx.peakidxShadowRoot).on("click", function(e){
            e.preventDefault();
            let listingId=$(this).attr("data-id");
            // console.log("click inquire", listingId);
        });
        // $(".zidxListingTourButton", this.zidx.peakidxShadowRoot).on("click", function(e){
        //     e.preventDefault();
        //     let listingId=$(this).attr("data-id");
        //     console.log("click tour", listingId);
        // });
        $(".zidxListingSaveButton", this.zidx.peakidxShadowRoot).on("click", async function(e){
            e.preventDefault();
            const repo = SavedListingRepository.getInstance(self.zidx);

            // Check limit before saving
            if (!repo.canSaveOrHide()) {
                self.zidx.showLoginForm();
                return;
            }

            const $saveButton=$(".zidxSearchResultSave", self.zidx.peakidxShadowRoot);
            if($saveButton.attr("data-saved")!="true") {
                $saveButton.trigger("click");
            }
            // Send to server if logged in
            let listingId = $(this).attr("data-id")!;
            let uniqueId = $(this).attr("data-unique-id");
            if (uniqueId && self.zidx.isContactLoggedIn()) {
                const contactSaveListing = ContactSaveListing.getInstance(self.zidx);
                const parsed = contactSaveListing.parseListingId(listingId);
                if (parsed) {
                    contactSaveListing.save({
                        listing_unique_id: parseInt(uniqueId, 10),
                        listing_index_id: parsed.listing_index_id,
                        listing_id: parsed.listing_id,
                        contact_x_listing_action: ContactListingAction.SAVE
                    });
                }
            }
        });
        const repo = SavedListingRepository.getInstance(self.zidx);
        $(".zidxListingHideButton", this.zidx.peakidxShadowRoot).each(function(){

            let listingId=$(this).attr("data-id")!;
            let uniqueId = $(this).attr("data-unique-id");
            if(repo.isHidden(listingId, uniqueId ? parseInt(uniqueId, 10) : 0)) {
                $(this).text("Show");
            }
        });
        $(".zidxListingHideButton", this.zidx.peakidxShadowRoot).on("click", async function(e){
            e.preventDefault();

            let listingId=$(this).attr("data-id")!;
            let uniqueId = $(this).attr("data-unique-id");
            const $saveButton=$(".zidxSearchResultSave", self.zidx.peakidxShadowRoot);
            if($saveButton.attr("data-saved")=="true") {
                $saveButton.trigger("click");
            }

            // Add to localStorage first
            repo.hideByStringId(listingId, uniqueId ? parseInt(uniqueId, 10) : 0);
            let isHidden=true;
            if(this.innerText=="Show") {
                isHidden=false;
            }

            console.log("click hide/show", listingId, uniqueId, this.innerText);
            // If not logged in, create guest account (this syncs all listings including this hide)
            if (!self.zidx.isContactLoggedIn()) {
                await repo.createGuestAccount();
            } else if (uniqueId) {
                // Already logged in - send to server then navigate
                const contactSaveListing = ContactSaveListing.getInstance(self.zidx);
                const parsed = contactSaveListing.parseListingId(listingId);
                if (parsed) {
                    const obj={
                        listing_unique_id: parseInt(uniqueId, 10),
                        listing_index_id: parsed.listing_index_id,
                        listing_id: parsed.listing_id,
                        contact_x_listing_action: ContactListingAction.HIDE
                    };
                    if(this.innerText=="Hide") {
                        await contactSaveListing.hide(obj);
                        this.innerText="Show";
                    }else{
                        await contactSaveListing.show(obj);
                        this.innerText="Hide";
                    }
                }
            }
            if(isHidden) {
                repo.navigateBackToSearch();
            }
        });
        $(".zidxListingShareButton", this.zidx.peakidxShadowRoot).on("click", function(e){
            e.preventDefault();
            let listingId=$(this).attr("data-id");
            console.log("click share", listingId);
        });
        // Handle Sign In button - hide if already logged in, show modal on click
        if (this.zidx.isContactLoggedIn() && !this.zidx.isContactGuest()) {
            $(".zidxContactRegisterButtonContainer", this.zidx.peakidxShadowRoot).hide();
        } else {
            $(".zidxContactRegisterButton", this.zidx.peakidxShadowRoot).on("click", function(e){
                e.preventDefault();
                self.zidx.showLoginForm();
            });
        }
        if($("#listingDetailSlideshow1", this.zidx.peakidxShadowRoot).length>0) {
            let tempSlideData = $("#listingDetailSlideshow1", this.zidx.peakidxShadowRoot).attr("data-slide-data")!;
            if (this.slideData != tempSlideData || $("#listingDetailSlideshow1 .zidxMultiPanelSlide1", this.zidx.peakidxShadowRoot).length == 0) {
                this.slideData = tempSlideData;
                // console.log("slideData", this.slideData);
                let arrSlide: string[] = JSON.parse(this.slideData);
                if (arrSlide.length > 1) {
                    var options = new ZIDXMultiPanelSliderOptions();
                    options.arrSlide = arrSlide;
                    options.selector = "#listingDetailSlideshow1";
                    options.pager = true;
                    options.pagerStyle = 'zidxMultiPanelCircles';
                    options.auto = false;
                    options.timeout = 5000;
                    options.touchSwipe = true;
                    options.nextPrevious = true;
                    options.nextButton = '<img src="'+this.zidx.options.staticDomain+'/_forever/static/images/arrow-right.png" width="25" height="44" alt="Next Photo">';
                    options.previousButton = '<img src="'+this.zidx.options.staticDomain+'/_forever/static/images/arrow-left.png" width="25" height="44" alt="Previous Photo">';
                    options.nextPreviousCenterClass = "#listingDetailSlideshow1 .zidxMultiPanelSlide";
                    options.slideWidthPercent = 100;
                    this.slider = new ZIDXMultiPanelSlider(options, this.zidx);
                }
            } else if (this.slider != null) {
                this.slider.reinit();
            }
        }

        let rect=$(".zidxListingDetailContainer .zidxContainer", this.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
        let schoolsContainer=
            $(".zidxListingDetailSchools", this.zidx.peakidxShadowRoot)[0];
        // console.log("zidxListingDetailSchools", schoolsContainer.parentNode, schoolsContainer.parentNode!.parentNode);
        if(schoolsContainer!=null && schoolsContainer.parentNode!=null && schoolsContainer.parentNode.parentNode!=null) {
            let schoolsMapAccordionItem = <HTMLDivElement>schoolsContainer.parentNode!.parentNode!;
            $(schoolsMapAccordionItem).on("click", function (this, e: JQuery.ClickEvent) {
                e.preventDefault();
                console.log("click schools");
                let latitude = $(schoolsContainer).attr("data-latitude")!;
                let longitude = $(schoolsContainer).attr("data-longitude")!;
                let iframe = document.createElement("iframe");

                iframe.id = "zidxSchoolsIframe";
                iframe.width="100%";
                iframe.height = "500";
                iframe.style.border = "0px";
                iframe.src = "https://www.greatschools.org/widget/map?lat="+encodeURIComponent(latitude)+"&lon="+encodeURIComponent(longitude)+"&width="+Math.round(rect.width)+"&height="+iframe.height+"&zoom=13&t=" + self.zidx.options.versionDate;
                $(schoolsContainer).append(iframe);
            });
        }
        let walkscoreContainer=
            $(".zidxListingDetailWalkscore", this.zidx.peakidxShadowRoot)[0];
        if(walkscoreContainer!=null && walkscoreContainer.parentNode!=null && walkscoreContainer.parentNode.parentNode!=null) {
            let walkscoreMapAccordionItem = <HTMLDivElement>walkscoreContainer.parentNode!.parentNode!;
            $(walkscoreMapAccordionItem).on("click", function (this, e: JQuery.ClickEvent) {
                e.preventDefault();
                let address = $(walkscoreContainer).attr("data-address")!;
                let iframe = document.createElement("iframe");

                iframe.id = "zidxWalkscoreIframe";
                function getBadgeHeight(rect:DOMRect) {
                    if (rect.width < 400) {
                        return '460';
                    }else if (rect.width < 470) {
                        return '509';
                    } else if (rect.width < 600) {
                        return '609';
                    } else {
                        return '764';
                    }
                }
                iframe.width="100%";
                iframe.height = getBadgeHeight(rect);
                iframe.style.border = "0px";
                iframe.src = self.zidx.accountDomain + "/static/walkscore.html?address=" + encodeURIComponent(address) + "&t=" + self.zidx.options.versionDate;
                $(walkscoreContainer).append(iframe);
                $(window).off("clientresize.zidxWalkscore resize.zidxWalkscore").on("clientresize.zidxWalkscore resize.zidxWalkscore", function(){
                    let container=$(".zidxListingDetailContainer .zidxContainer", self.zidx.peakidxShadowRoot)[0];
                    if(!container){
                        $(window).off("clientresize.zidxWalkscore resize.zidxWalkscore");
                        return;
                    }
                    let rect=container.getBoundingClientRect();
                    iframe.height = getBadgeHeight(rect);
                });
            });
        }

        let mapLoaded=false;
        let mapContainer=this.zidx.peakidxShadowRoot.getElementById("zidxListingDetailMap")!;
        if(mapContainer!=null && mapContainer.parentNode!=null && mapContainer.parentNode.parentNode!=null) {
            this.mapAccordionItem = <HTMLDivElement>mapContainer.parentNode!.parentNode!;
            $(this.mapAccordionItem).on("click", function (this, e: JQuery.ClickEvent) {
                e.preventDefault();

                // console.log("trying to hideMap mapLoaded:"+mapLoaded);
                if (mapLoaded) {
                    mapLoaded = false;
                    self.zidx.zidxMap.hideMap();
                    return;
                }
                self.zidx.zidxBase.loadMap(function () {
                    self.positionDetailMap();
                    mapLoaded = true;
                });
            });
            $(window).off("clientresize.zidxDetailMap resize.zidxDetailMap").on("clientresize.zidxDetailMap resize.zidxDetailMap", function(){
                let mapContainerPosition=mapContainer.getBoundingClientRect();
                if(mapContainerPosition.width==0){
                    return;
                }
                if(mapLoaded) {
                    var p=self.positionDetailMap();
                }
            });
        }
        var listingViewGate = new ListingViewGate(this.zidx);

    }
    positionDetailMap(){
        let mapContainer=this.zidx.peakidxShadowRoot.getElementById("zidxListingDetailMap")!;
        let latitudeString=mapContainer.getAttribute("data-latitude");
        let longitudeString=mapContainer.getAttribute("data-longitude");
        // console.log("positionDetailMap", mapContainer);
        if(latitudeString!=null && !isNaN(parseFloat(latitudeString)) && longitudeString!=null && !isNaN(parseFloat(longitudeString))){
            let latitude=parseFloat(latitudeString);
            let longitude=parseFloat(longitudeString);
            let mapContainerPosition=mapContainer.getBoundingClientRect();
            this.zidx.displayLoadMore();
            $(".zidxMapMarkerHidden", this.zidx.peakidxShadowRoot).removeClass("zidxMapMarkerHidden");
            $(".zidxMapMarker", this.zidx.peakidxShadowRoot).addClass("zidxMapMarkerHidden");

            let mapIframeElement=this.zidx.peakidxShadowRoot.querySelector("#zidxMapIframe")! as HTMLIFrameElement;
            // console.log("positionMap called", mapIframeElement);
            mapIframeElement.style.zIndex="2";
            mapIframeElement.style.display="block";
            if(mapIframeElement) {
                this.zidx.zidxMap.mode="marker";
                mapIframeElement.style.left = Math.round(mapContainerPosition.x -10) + "px";
                mapIframeElement.style.position="absolute";
                // console.log("listingDetail height", mapIframeElement, mapContainerPosition.width, mapContainerPosition.height);
                mapIframeElement.width=(mapContainerPosition.width-16)+"px";
                mapIframeElement.height=mapContainerPosition.height+"px";
                if($("#zidxComponentContainer", this.zidx.peakidxShadowRoot).length==0) {
                    let bodyRect=$("#zidxBodyContainer", this.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
                    mapIframeElement.style.left=mapContainerPosition.x+"px";
                    mapIframeElement.style.top=(mapContainerPosition.top-bodyRect.y)+"px";
                }else{
                    let bodyRect=$("#zidxComponentContainer", this.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
                    mapIframeElement.style.left=(mapContainerPosition.x-bodyRect.x)+"px";

                    let embeddedBody=$(".zidxEmbeddedBody", this.zidx.peakidxShadowRoot);
                    if(embeddedBody.length!=0) {
                        let embeddedBodyRect = embeddedBody[0].getBoundingClientRect();
                        if (this.zidx.peakidxShadowRoot instanceof ShadowRoot) {
                            mapIframeElement.style.top = (mapContainerPosition.top + Math.abs(embeddedBodyRect.top)) + "px";
                        } else {
                            mapIframeElement.style.top = (mapContainerPosition.top + Math.abs(embeddedBodyRect.top)) + "px";
                        }
                    }else{
                        // console.log("load map here", mapContainerPosition.top, bodyRect.y);
                        mapIframeElement.style.top = (mapContainerPosition.top-bodyRect.y) + "px";
                    }
                }
                let self=this;
                this.zidx.zidxMap.mapIframePromise?.then(function(response:any){
                    let markerMessage={
                        type:"marker",
                        latitude:latitude,
                        longitude:longitude,
                    }
                    self.zidx.zidxMap.firstMapLoad=false;
                    mapIframeElement.contentWindow!.postMessage(markerMessage, self.zidx.accountDomain);

                    if(self.mapAccordionItem) {
                        // console.log("mapAccordion y", self.zidx.getAbsPosition(self.mapAccordionItem).y, window.scrollY);
                        // if (self.zidx.peakidxShadowRoot instanceof ShadowRoot) {
                            window.scrollTo(0, self.zidx.getAbsPosition(self.mapAccordionItem).y + window.scrollY);
                        // } else {
                        //     window.scrollTo(0, self.zidx.getAbsPosition(self.mapAccordionItem).y);
                        // }
                    }
                }).catch(function(error:any){
                    console.error("Error loading map iframe:", error);
                });
            }
        }
    }
}